import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
    facebook,
    fooBlog,
    instagram,
    logoFooter2,
    pay,
    send,
    twitter,
    youtube,
} from "../Constant";
import config from "../config";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { START_LOADER, STOP_LOADER } from "../redux/actions/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = ({ auth, startLoading, stopLoading }) => {
    const [email, setEmail] = useState("");

    const newsLetter = async () => {
        try {
            startLoading();
            const res = await config.postApi(
                config.services.newsletter(),
                config.defaultHeaders,
                JSON.stringify({ email })
            );
            stopLoading();
            if (res) {
                setEmail("");
                Swal.fire({
                    icon: "success",
                    title: "Email Sent",
                    text: "Our expert will contact you soon!",
                });
            }
        } catch (e) {
            stopLoading();
            console.log(e);
        }
    };

    return (
        <>
            {/* <!-- Footer --> */}
            <footer className="footer text-lg-start bg-light text-muted">
                {/* <!-- Section: Social media */}
                <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
                    {/* <div className="me-5 d-none d-lg-block">
                        <span>Get connected with us on social networks:</span>
                    </div> */}

                    <div>
                        <a
                            href="https://facebook.com"
                            target="_blank"
                            className="me-4 text-reset"
                        >
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a
                            href="https://twiitter.com"
                            target="_blank"
                            className="me-4 text-reset"
                        >
                            <i className="fab fa-twitter"></i>
                        </a>
                        <a
                            href="https://google.com"
                            target="_blank"
                            className="me-4 text-reset"
                        >
                            <i className="fab fa-google"></i>
                        </a>
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            className="me-4 text-reset"
                        >
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a
                            href="https://linkedin.com"
                            target="_blank"
                            className="me-4 text-reset"
                        >
                            <i className="fab fa-linkedin"></i>
                        </a>
                        <a
                            href="https://github.com"
                            target="_blank"
                            className="me-4 text-reset"
                        >
                            <i className="fab fa-github"></i>
                        </a>
                    </div>
                </section>
                {/* Section: Social media --> */}

                {/* <!-- Section: Links  --> */}
                <section className="footer-text">
                    <div className="container text-md-start mt-5">
                        {/* <!-- Grid row --> */}
                        <div className="row mt-3">
                            {/* <!-- Grid column --> */}
                            <div className="col-1-5 col-xl-3 col-sm-6 mx-auto mb-4 border-right1 py-1 footer-top">
                                {/* <!-- Content --> */}
                                <h6 className="text-uppercase fw-bold mb-4 text-left">
                                    <img src={logoFooter2} alt="footer logo" />
                                </h6>
                                <br />
                                <div className="social text-center">
                                    <a
                                        href="https://facebook.com"
                                        className="me-4 text-reset"
                                    >
                                        <i>
                                            <img src={facebook} alt="" />
                                        </i>
                                    </a>
                                    <a
                                        href="https://instagram.com"
                                        className="me-4 text-reset"
                                    >
                                        <i>
                                            <img src={instagram} alt="" />
                                        </i>
                                    </a>
                                    <a
                                        href="https://twitter.com"
                                        className="me-4 text-reset"
                                    >
                                        <i>
                                            <img src={twitter} alt="" />
                                        </i>
                                    </a>
                                    <a
                                        href="https://youtube.com"
                                        className="me-4 text-reset"
                                    >
                                        <i>
                                            <img src={youtube} alt="" />
                                        </i>
                                    </a>
                                </div>
                            </div>
                            {/* <!-- Grid column --> */}

                            {/* <!-- Grid column --> */}
                            <div className="col-1-5 col-xl-2 col-sm-6 mx-auto mb-4 py-1">
                                {/* <!-- Links --> */}
                                <h6 className=" fw-bold mb-4">
                                    <b> Quick Links</b>
                                </h6>
                                <p>
                                    <Link to="/" className="text-reset">
                                        Home
                                    </Link>
                                </p>
                                <p>
                                    <Link
                                        to={"/about-us"}
                                        className="text-reset"
                                    >
                                        About us
                                    </Link>
                                </p>
                                <p>
                                    <Link
                                        to={"/care-giver"}
                                        className="text-reset"
                                    >
                                        Care Services
                                    </Link>
                                </p>
                            </div>
                            {/* <!-- Grid column --> */}

                            {/* <!-- Grid column --> */}
                            <div className="col-1-5  col-xl-2 col-sm-6 mx-auto mb-4 border-right1 py-1">
                                {/* <!-- Links --> */}
                                <h6 className=" fw-bold mb-4"></h6>
                                {auth.loggedIn && auth.user.role != 2 && (
                                    <p style={{ paddingTop: "20px" }}>
                                        <Link
                                            id="footer-care-giver"
                                            to={"/care-giver-registration"}
                                            className="text-reset"
                                        >
                                            Become a Care Giver
                                        </Link>
                                    </p>
                                )}
                                <p>
                                    <Link
                                        to="/privacy-policy"
                                        className="text-reset"
                                    >
                                        Privacy Policy
                                    </Link>
                                </p>
                                <p>
                                    <Link
                                        to="/terms-and-conditions"
                                        className="text-reset"
                                    >
                                        Terms and Conditions
                                    </Link>
                                </p>
                                <p>
                                    <Link to="/covid" className="text-reset">
                                        Covid Prevention SOPs
                                    </Link>
                                </p>
                                <p>
                                    <Link
                                        to="/safety-work"
                                        className="text-reset"
                                    >
                                        Safety at work
                                    </Link>
                                </p>
                            </div>
                            {/* <!-- Grid column --> */}
                            {/* <!-- Grid column --> */}
                            <div className="col-1-5 col-xl-2 col-sm-6 mx-auto mb-4 border-right1 ">
                                {/* <!-- Links --> */}
                                <h6 className=" fw-bold mb-4">
                                    <b>Blogs</b>
                                </h6>
                                <img src={fooBlog} alt="" height="140" />
                            </div>
                            {/* <!-- Grid column --> */}

                            {/* <!-- Grid column --> */}
                            <div className="col-1-5 col-xl-3 col-sm-12 mx-auto mb-md-0 mb-4">
                                {/* <!-- Links --> */}
                                <h6 className=" fw-bold mb-4">
                                    <b> Connect with us</b>
                                </h6>
                                <p className="white">
                                    Get in touch with us for Expert Advice:
                                </p>
                                <form id="newsletterForm" action="#">
                                    <div className="input-group md-form form-sm form-2 pl-0">
                                        <input
                                            id="newsletter-email"
                                            className="form-control my-0 py-1 amber-border"
                                            type="email"
                                            placeholder="Enter Email Address..."
                                            aria-label="Enter Email Address..."
                                            value={email}
                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                onClick={newsLetter}
                                                className="input-group-text  btn-danger amber lighten-3"
                                                // id="basic-text1"
                                            >
                                                <img
                                                    src={send}
                                                    height="18"
                                                    className="white"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/* <!-- Grid column --> */}
                        </div>

                        <div className="col-md-12 text-center font-13 mt-4">
                            <b>Disclaimer</b> : We ensure that we adhere to the
                            principles of honesty and reality in advertising,
                            and all information accurately represents the
                            organization's scope of services provided, including
                            prices, licenses, and testimonials.{" "}
                        </div>
                        {/* <!-- Grid row --> */}
                    </div>
                </section>
                {/* <!-- Section: Links  --> */}
                <div className="col-md-12 footer-copyright">
                    <div className="container ">
                        <div className="row">
                            <div className="col-md-6">
                                © 2022 <Link to="/"> MyHomeHelper.LLC</Link> |
                                All Rights Reserved
                            </div>
                            <div className="col-md-6">
                                <img src={pay} className="float-right" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    startLoading: () => dispatch({ type: START_LOADER }),
    stopLoading: () => dispatch({ type: STOP_LOADER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
